import React, { useEffect, useState } from 'react';

interface AutoCloseMessageProps {
  message: string; // 显示的消息
  show: boolean; // 控制显示状态
  duration?: number; // 显示的持续时间（毫秒），默认为 3000 毫秒
}

export const Message: React.FC<AutoCloseMessageProps> = ({ message, show, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (show) {
      setIsVisible(true);

      const timer = setTimeout(() => {
        setIsVisible(false);
      }, duration);

      // 清除计时器
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [show, duration]);

  if (!isVisible) {
    return null; // 如果不需要显示，返回 null
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-opacity-50 z-50 pointer-events-none">
      <div className="pt-2 pb-2 pl-4 pr-4 bg-black bg-opacity-70 text-white rounded-lg shadow-lg transition-opacity duration-500 ease-in-out pointer-events-auto text-xs">
        <p>{message}</p>
      </div>
    </div>
  );
};
